import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import image1 from "../../../assets/images/windfarm.jpg";
// import image2 from "../../../assets/images/creatures.jpg";

const Intro = () => {
  return (
    <Box paddingTop={{ xs: "20%", sm: "10%" }}>
      <Box width={"100%"}>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          position="relative"
          marginLeft={{ xs: "0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "30vh", sm: "1050px" }}
            display={{ xs: "none", sm: "block" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              width: "100%",
            }}
            src={image1}
            alt={"about-image"}
          />
          <Box
            width={{ xs: "100%", sm: "100%" }}
            marginTop={{ xs: "25%", sm: "0%" }}
            bgcolor={"#fff"}
            padding={{ xs: "0%", sm: "4%" }}
            top={{ xs: "50%", sm: "5%" }}
            left={{ xs: "0%", sm: "90%" }}
            position={"absolute"}
          >
            <Typography
              variant="h6"
              color="#9DCC49"
              fontWeight={800}
              paddingTop={"1%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              {" "}
              <Box component={"span"}>
                <WaterIcon
                  sx={{
                    width: 23,
                    height: 23,
                  }}
                />
              </Box>{" "}
              Who We Are
            </Typography>
            <Typography
              variant="h3"
              color="#317ABE"
              fontWeight={700}
              paddingTop={"2%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Nurturing Climate-smart Blue Economies.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              Blue Echo Foundation is a Nigeria-based non-profit organization
              dedicated to restoring, protecting, and sustainably managing the
              country’s marine, mangrove, and coastal ecosystems while advancing
              inclusive blue economy development.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              Nigeria’s coastline supports millions of livelihoods and underpins
              national food security, trade, and climate resilience. Yet these
              ecosystems face mounting pressures from coastal erosion,
              pollution, habitat loss, overfishing, climate change, and
              unplanned development. Blue Echo Foundation exists to address
              these challenges through integrated, science-based, and
              community-led solutions.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              We work at the intersection of marine conservation, sustainable
              fisheries and aquaculture, climate resilience, and coastal
              livelihoods, partnering with coastal communities, government
              institutions, research organizations, and the private sector. Our
              approach combines ecosystem restoration, policy engagement,
              applied research, and enterprise development to ensure that
              environmental protection delivers tangible social and economic
              benefits.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              Across Nigeria’s coastal zones, lagoons, estuaries, and nearshore
              waters, we support mangrove restoration, marine and coastal
              habitat protection, sustainable blue livelihoods for women and
              youth, and the adoption of climate-smart and nature-based
              solutions. We also serve as a platform for knowledge generation
              and advocacy, strengthening marine and coastal governance through
              data, innovation, and inclusive decision-making.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              By aligning conservation outcomes with economic opportunity, Blue
              Echo Foundation is helping build a resilient, equitable, and
              sustainable marine and coastal future for Nigeria.
            </Typography>
          </Box>
        </Box>
        <Box display={{ xs: "block", sm: "none" }}>
          <Box
            width={{ xs: "100%", sm: "100%" }}
            marginTop={{ xs: "20%", sm: "0%" }}
            bgcolor={"#fff"}
            padding={{ xs: "0%", sm: "4%" }}
          >
            <Typography
              variant="h6"
              color="#9DCC49"
              fontWeight={800}
              paddingTop={"1%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              {" "}
              <Box component={"span"}>
                <WaterIcon
                  sx={{
                    width: 23,
                    height: 23,
                  }}
                />
              </Box>{" "}
              Who We Are
            </Typography>
            <Typography
              variant="h3"
              color="#317ABE"
              fontWeight={700}
              paddingTop={"2%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Nurturing Climate-smart Blue Economies.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              Blue Echo Foundation is a Nigeria-based non-profit organization
              dedicated to restoring, protecting, and sustainably managing the
              country’s marine, mangrove, and coastal ecosystems while advancing
              inclusive blue economy development.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              Nigeria’s coastline supports millions of livelihoods and underpins
              national food security, trade, and climate resilience. Yet these
              ecosystems face mounting pressures from coastal erosion,
              pollution, habitat loss, overfishing, climate change, and
              unplanned development. Blue Echo Foundation exists to address
              these challenges through integrated, science-based, and
              community-led solutions.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              We work at the intersection of marine conservation, sustainable
              fisheries and aquaculture, climate resilience, and coastal
              livelihoods, partnering with coastal communities, government
              institutions, research organizations, and the private sector. Our
              approach combines ecosystem restoration, policy engagement,
              applied research, and enterprise development to ensure that
              environmental protection delivers tangible social and economic
              benefits.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              Across Nigeria’s coastal zones, lagoons, estuaries, and nearshore
              waters, we support mangrove restoration, marine and coastal
              habitat protection, sustainable blue livelihoods for women and
              youth, and the adoption of climate-smart and nature-based
              solutions. We also serve as a platform for knowledge generation
              and advocacy, strengthening marine and coastal governance through
              data, innovation, and inclusive decision-making.
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingBottom={"2%"}
              lineHeight={1.75}
              textAlign={"left"}
            >
              By aligning conservation outcomes with economic opportunity, Blue
              Echo Foundation is helping build a resilient, equitable, and
              sustainable marine and coastal future for Nigeria.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Intro;
